import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import LoadingBull from "../loading-bull/";
import { MOOMOO_DARK_INFO } from "../loading-bull/config";
var UiIndicatorMoomooDark = {
  name: 'UiIndicatorMoomooDark',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 32
    }
  },
  model: {
    prop: 'value'
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var data = {
      props: {
        value: this.value,
        size: this.size,
        imageInfo: MOOMOO_DARK_INFO
      }
    };
    return h(LoadingBull, _mergeJSXProps([{}, data, {
      "model": {
        value: _this.value,
        callback: function callback($$v) {
          _this.value = $$v;
        }
      }
    }]));
  }
};

UiIndicatorMoomooDark.install = function (Vue) {
  Vue.component(UiIndicatorMoomooDark.name, UiIndicatorMoomooDark);
};

export default UiIndicatorMoomooDark;